import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import guidlines from './Authors- guidelines.pdf'
import { Link, useParams } from 'react-router-dom';
import AxiosHelper from '../../helper/AxiosHelper';
import { toast } from 'react-toastify';


const CaseStudy = () => {
	const params = useParams()
	const [categoryArticles, setCategoryArticles] = useState([])
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		getCategories()
	}, []);

	const getCategories = async () => {
		var { data } = await AxiosHelper.getData(`doctor-corners?catlist=${params?.category_slug}`);

		if (data.status === true) {
			setCategoryArticles(data.data)
			setIsLoading(false)
		} else {
			toast.error(data.message);
		}
	}
	return (
		<>
			<Banner title={categoryArticles[0]?.categories[0]?.name} />
			<Container className='case-study-skeleton articles'>
				<Row className="mb-5 mt-5">
					{isLoading
						? Array(8).fill(0).map((_, index) => (
							<Col
								xs={6}
								md={4}
								lg={3}
								xl={2}
								className="d-flex justify-content-center mb-4"
								key={index}
							>
								<div
									className="skeleton-img"
									style={{
										borderRadius: "20px",
										width: "180px",
										height: "150px",
									}}
								/>
								<div className="skeleton-title mt-3" />
							</Col>
						))
						: categoryArticles.map((item, index) => (
							<Col
								xs={6}
								md={4}
								lg={3}
								xl={2}
								className="d-flex justify-content-center mb-4 px-lg-3 customMargin"
								key={index}
							>
								{item?.document_file ? (
									<a
										href={item?.document_file}
										className="list-nav"
										style={{ textDecoration: "none" }}
										rel="noopener noreferrer"
										target='_blank'
									>
										<div className="cardBox text-center">
											<img
												className='thumbImg' 
												src={item.image}
												alt={item.title || "Image"}
												title={item.title || "Image"}
											/>
											<h3 className="cardTitle mt-4">{item.title}</h3>
										</div>
									</a>
								) : (
									<></>
								)}
							</Col>
						))}
				</Row>
			</Container>

		</>
	)
}

export default CaseStudy;

export const Banner = ({ title }) => {
	return (
		<div className='bannerBody'>
			<h1 className='bannerHeading'>{title}</h1>
			{/* <h6 className='subBannerHeading'><a target='_blank' href={guidlines} rel="noreferrer">Guidelines for Article Submission</a></h6> */}
		</div>
	)
}